<template>
  <div class="cardbag-container">
    <div v-for="(item, key) in couponList" :key="key" class="item">
      <div class="content">
        <div class="container"><span class="title">{{ item.title }}</span><span class="desc">{{ substring(item.desc, 10, true) }}</span></div>
        <div class="expire">{{ item.end_time }}到期</div>
      </div>
      <div class="action" @click="handleUse(item)">去使用</div>
    </div>
    <no-data v-show="nodata" :remark="'您还没有礼包领取的记录哦'" />
  </div>
</template>

<script>
import { coupons } from '@/api/coupon'
import { substring } from '@/utils/index'
import NoData from '@/components/NoData'
export default {
  name: 'Index',
  components: {
    NoData
  },
  data () {
    return {
      nodata: false,
      couponList: []
    }
  },
  created () {
    this.init()
  },
  mounted() {
  },
  methods: {
    init() {
      this.nodata = false
      coupons().then((response)=>{
        this.couponList = response.data.data
        if(this.couponList.length < 1) {
          this.nodata = true
        }
      })
    },
    handleUse(item) {
      if(item.user_album != -1){
        this.$router.push({path: '/play', query: {id: item.user_album}})
        return
      }
      this.$router.push({path: '/'})
    },
    substring
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.cardbag-container{
  padding: 13px 16px;
  background-color: #fff;
  min-height: calc(100vh - 26px);
  .item{
    display: flex;
    align-items: center;
    color: #fff;
    background: url('~@/assets/coupon-bg.png') no-repeat center top;
    background-size: 100% 100%;
    // background-color: rgb(250, 193, 212);
    margin-bottom: 6px;
    .content{
      flex: 1;
      padding-left: 16px;
      padding-bottom: 6px;
      text-align: left;
      .container{
        height: 48px;
      }
      .title{
        font-size: 26px;
        margin-right: 6px;
      }
      .desc{
        color: #751D00;
      }
      .expire{
        text-align: left;
        font-size: 14px;
        margin-top: 6px;
      }
    }
    .action{
      font-size: 18px;
      border-left: #fff 1px solid;
      padding: 16px 13px;
    }
  }
  .nodata{
    padding-top: 64px;
    .title{
      color: #333;
      font-size: 18px;
      margin-top: 43px;
    }
    .desc{
      color: #999;
      font-size: 14px;
      margin-top: 13px;
    }
  }
}
</style>
